import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.incident-by-funkprotokoll-fall2';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsIncidentByFunkprotokollFall2Effects {

    IncidentByFunkprotokollFall2$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_INCIDENT_BY_FUNKPROTOKOLL_FALL2),
        mergeMap((x: ac.GetIncidentByFunkprotokollFall2Action) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getIncidentByFunkprotokollFall2(x.fall_id).pipe(
                map((result: any) => {
                    return new ac.GetIncidentByFunkprotokollFall2ErfolgreichAction(result, x.fall_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetIncidentByFunkprotokollFall2FehlerAction(error, x.fall_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentsQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentsQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentsQueryService);
        }
        return this.service;
    }
}
